module.exports = __webpack_public_path__ + "img/2.99da75e9.png";